const config = {
  apiURL: `${process.env.REACT_APP_APIURL}/`,
  IdentityClientID: 'admin',
}

export { config as default }
